import { useEffect } from 'react';
import {  useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';

import { loadOfferThunk, statusSelector } from '../store';
import { useOfferRouteParams } from './useOfferRouteParams';

export function useLoadOffer() {
    const dispatch = useAppDispatch();

    const { orderId, orderRoleId } = useOfferRouteParams();

    const status = useSelector(statusSelector);

    useEffect(() => {
        if (status !== 'idle') {
            return;
        }

        dispatch(loadOfferThunk({ orderId, orderRoleId }));
    }, [ dispatch, status, orderId, orderRoleId ]);
}
